
import React from 'react';
import PersonalInfoSection from './PersonalInfoSection';
import ContentSection from './ContentSection';
import FormActions from './FormActions';
import { useProductionForm } from '@/hooks/production/useProductionForm';

const ProductionForm: React.FC = () => {
  const {
    loading,
    answer,
    setAnswer,
    name,
    setName,
    title,
    setTitle,
    company,
    setCompany,
    context,
    setContext,
    contextUrl,
    setContextUrl,
    contextImageUrl,
    setContextImageUrl,
    contextImageCaption,
    setContextImageCaption,
    question,
    setQuestion,
    photoUrl,
    setPhotoUrl,
    photographerCredit,
    setPhotographerCredit,
    tags,
    setTags,
    handleSubmit,
    VALID_TAGS
  } = useProductionForm();

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Personal info section */}
      <PersonalInfoSection 
        name={name}
        setName={setName}
        title={title}
        setTitle={setTitle}
        company={company}
        setCompany={setCompany}
        photoUrl={photoUrl}
        setPhotoUrl={setPhotoUrl}
        photographerCredit={photographerCredit}
        setPhotographerCredit={setPhotographerCredit}
      />
      
      {/* Interview content section */}
      <ContentSection 
        context={context}
        setContext={setContext}
        contextUrl={contextUrl}
        setContextUrl={setContextUrl}
        contextImageUrl={contextImageUrl}
        setContextImageUrl={setContextImageUrl}
        contextImageCaption={contextImageCaption}
        setContextImageCaption={setContextImageCaption}
        question={question}
        setQuestion={setQuestion}
        answer={answer}
        setAnswer={setAnswer}
        tags={tags}
        setTags={setTags}
        validTags={VALID_TAGS}
      />
      
      <FormActions loading={loading} />
    </form>
  );
};

export default ProductionForm;
